// store/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

interface GroupPermission {
    [key: string]: string[] | undefined;
}

interface PermissionState {
    groupPermission: GroupPermission;
}

const initialState: PermissionState = {
    groupPermission: {},
};

const permissionSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setGroupPermission(state, action) {
      state.groupPermission = action.payload;
    },
  },
});

export const { setGroupPermission } = permissionSlice.actions;
export default permissionSlice.reducer;
